'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { addIconToChildren, CoreButton, DEFAULT_BUTTON_SIZE } from '../../core-components/CoreButton';
import { LoadingContainer, NotLoadingContainer, Container } from './elements';
import { AsurionLoadingSpinner } from '../Loaders';
import { buttonSizeToLoaderSize } from './utils';
export const Button = /*#__PURE__*/React.forwardRef(({
  children,
  iconSrc,
  iconSide = 'left',
  size = DEFAULT_BUTTON_SIZE,
  isLoading = false,
  disabled = false,
  ...rest
}, fRef) => /*#__PURE__*/React.createElement(CoreButton, _extends({
  "data-aui": "button",
  ref: fRef,
  size: size,
  hasChildren: !!children,
  iconSide: iconSide,
  hasIcon: !!iconSrc,
  disabled: disabled || isLoading
}, rest), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(NotLoadingContainer, {
  isLoading: isLoading,
  "data-testid": "button-not-loading-container"
}, addIconToChildren({
  children,
  iconSrc,
  iconSide,
  size
})), /*#__PURE__*/React.createElement(LoadingContainer, {
  isLoading: isLoading,
  "data-testid": "button-loading-container"
}, isLoading && /*#__PURE__*/React.createElement(AsurionLoadingSpinner, {
  width: buttonSizeToLoaderSize[size]
})))));